<app-navigation-header title="Billing" i18n-title="@@billingMaintab-Billing">
	<div class="billing-contract-container">
		<!-- Billing header container for current/future/past steps -->
		<div class="horizontal-stepper-label-container">
			<span>
				<app-access-horizontal-stepper-labels [steps]="steps" [currentStep]="currentStep">
				</app-access-horizontal-stepper-labels>
			</span>
			<span class="mat-stepper-navigator">
				@if (currentStep !== 0 && currentStep !== 2) {
					<button
						class="secondary-small-button"
						(click)="onPressBack()"
						i18n="@@billingContract-backButton"
						data-automation-id="billing-contract-back-button"
					>
						Back
					</button>
				}
				@if (currentStep !== 2) {
					<button
						(click)="onPressContinue()"
						class="right-button"
						data-automation-id="billing-contract-continue-button"
						[ngClass]="{
							'primary-small-button': enableContinueButton,
							'primary-small-button-disabled': !enableContinueButton,
						}"
						i18n="@@billingContract-continueButton"
					>
						Continue
					</button>
				}
			</span>
		</div>

		@if (currentStep === 0) {
			<div>
				<app-billing-add-contract
					(continueContractRegistration)="continueContractRegistration($event)"
					[savedAddContractFormGroup]="savedAddContractFormGroup"
					[savedAddOnBillingFormGroup]="savedAddOnBillingFormGroup"
				></app-billing-add-contract>
			</div>
		}
		@if (currentStep === 1 && savedBillingContract) {
			<div>
				<app-billing-edit-contract [billingContract]="savedBillingContract"></app-billing-edit-contract>
			</div>
		}
		@if (currentStep === 2) {
			<div>
				<app-billing-confirm-contract
					[companyName]="savedBillingContract ? savedBillingContract.company.name : ''"
				></app-billing-confirm-contract>
			</div>
		}
	</div>
</app-navigation-header>
